import React from 'react';
import { motion } from 'framer-motion';
import { ContactForm } from './ContactForm';
export function HeroSection() {
  return <section className="relative bg-[#0A2540] text-white" style={{
    height: 'auto',
    minHeight: '1000px',
    overflow: 'visible'
  }} data-id="element-75">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-76" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative z-10" data-id="element-77">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-78">
          {/* Left Column: Content + Image */}
          <motion.div className="lg:col-span-7 space-y-8" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-79">
            <div className="space-y-6" data-id="element-80">
              <h1 className="leading-tight tracking-tight" data-id="element-81">
                <span className="block text-4xl md:text-5xl lg:text-6xl font-bold" data-id="element-82">
                  Custom Boat Dealer Websites
                </span>
                <span className="block text-2xl md:text-3xl lg:text-4xl font-semibold mt-3 text-gray-300" data-id="element-83">
                  Built to <span className="text-[#D4AF37]" data-id="element-84">Sell Boats</span> -
                  Not Just Show Them
                </span>
              </h1>

              <p className="text-lg md:text-xl text-gray-300 max-w-2xl leading-relaxed" data-id="element-85">
                Your website is your virtual showroom. If it isn't built for
                boat buyers, optimized for search, and connected to your
                inventory system - you're leaving sales (and time) on the table.
              </p>
            </div>

            {/* Device Mockup Image */}
            <div className="relative rounded-xl overflow-hidden max-w-2xl -translate-x-10" data-id="element-86">
              <img src="https://cdn.magicpatterns.com/uploads/hFXkCVKr4nFeCeF1THbgkw/bluewater-marine-device.jpg-Photoroom.png" alt="Bluewater Marine website on desktop and mobile devices" className="w-full h-auto" data-id="element-87" />
            </div>
          </motion.div>

          {/* Right Column: Form */}
          <motion.div className="lg:col-span-5" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-88">
            <ContactForm id="hero-form" data-id="element-89" />
          </motion.div>
        </div>
      </div>
    </section>;
}